import { amWindow } from '../types';

const gainsight = {
  identify: async (userObject: any, accountObject?: any) => {
    // This is used to identify a unique user, across various tracking vendors
    if (amWindow.aptrinsic && userObject) {
      amWindow.aptrinsic('identify', userObject, accountObject);
    }
  },

  reset: () => {
    if (amWindow.aptrinsic) {
      amWindow.aptrinsic('reset');
    }
  },

  track: (name: string, params?: any) => {
    if (amWindow.aptrinsic) {
      amWindow.aptrinsic('track', name, params);
    }
  },
};

export default gainsight;
